'use client';

import {usePathname, useRouter, useSearchParams} from 'next/navigation';
import {useEffect} from 'react';

// Keep in sync with backend
export const PARTNER_REFERRAL_COOKIE = 'dagster-plus-partner-referral';

// Didn't want to use referrer since its a common query string param so add a "d" for dagster.
export const PARTNER_REFERRAL_PARAM_KEY = 'dreferrer';

/**
 * If a `dreferrer` parameter is provided, track the value in a cookie, then
 * redirect to the current path without the `dreferrer` parameter.
 */
export default function SetReferrerCookie() {
  const searchParams = useSearchParams();
  const referrer = searchParams.get(PARTNER_REFERRAL_PARAM_KEY);
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (referrer) {
      document.cookie = `${PARTNER_REFERRAL_COOKIE}=${referrer};path=/;`;
      const newParams = new URLSearchParams(searchParams);
      newParams.delete(PARTNER_REFERRAL_PARAM_KEY);
      const targetPath = `${pathname}?${newParams.toString()}`;
      router.replace(targetPath);
    }
  });

  return null;
}
